export type ImportExcelErrorInfo = {
  title: string;
  detail: string;
  sheet?: string;
  row?: number;
  code?: string;
  status?: number;
  url?: string;
};

export const parseImportExcelError = (data: any): ImportExcelErrorInfo => {
  const title = data?.title || data?.error || 'Eroare la import';
  const detailBase =
    data?.detail ||
    data?.message ||
    (data?.status ? `HTTP ${data.status}${data?.statusText ? ' ' + data.statusText : ''}` : '');

  const sheet = data?.sheet || data?.Sheet || data?.sheetName;

  const rawRow = data?.row ?? data?.RowIndex ?? data?.rowIndex;
  const rowNum = Number(
    typeof rawRow === 'object' && rawRow !== null && 'value' in rawRow
      ? (rawRow as any).value
      : rawRow
  );
  const row = Number.isFinite(rowNum) ? rowNum : undefined;

  const code = data?.code || data?.Code;

  return {
    title,
    detail: detailBase || 'Nu am primit detalii de la server.',
    sheet,
    row,
    code,
    status: data?.status,
    url: data?.url,
  };
};